// ─── Shared design tokens ──────────────────────────────────────────
// The gradient COLOR logic lives in toolGradients.js (single source —
// tool rule + parent rule). This file holds the few remaining
// non-gradient values that were otherwise hardcoded per-component and
// could drift (Ian: "less loose stuff, less to break").
//
// Anything visual that is NOT a per-tool/per-suite gradient color
// belongs here, derived once, consumed everywhere.

export const TOKENS = {
  // Tile / card geometry
  tileRadius: 18,        // tool card tile corner radius (px)
  suiteRadiusRatio: 0.22, // SuiteMark tile radius as a ratio of size

  // Surfaces
  cardBg: "#13141F",     // panel / accordion / card background
  cardBorder: "#1C1E2E", // hairline divider / inactive border
  appBg: "#0A0B14",      // app background

  // Text
  textPrimary: "#E8E9F3",
  textBody: "#C8CADF",
  textMuted: "#9A9DBE",
  textFaint: "#7C8099",
  textDim: "#5B5E7A",

  // Tool-card label (readable by default — spec §2.8 / Priority 3)
  labelOpacityRest: 0.9,
  labelOpacityActive: 1,
};

export default TOKENS;
